<template>
    <tr>
        <td>
            {{ number }}
        </td>
        <td class="w-50">
            <label :for="id">{{ label }}</label>
        </td>
        <td class="text-right">
            <label class="d-inline-block mr-2 align-middle p-1 bg-light rounded">
                <span class="align-top">Yes</span>
                <input
                    type="checkbox"
                    v-model="form[id]"
                    :id="id"
                    :name="id"
                    true-value="Yes"
                >
            </label>
            <label class="d-inline-block mr-2 align-middle p-1 bg-light rounded">
                <span class="align-top">No</span>
                <input
                    type="checkbox"
                    v-model="form[id]"
                    :name="id"
                    true-value="No"
                >
            </label>
            <label class="d-inline-block mr-2 align-middle p-1 bg-light rounded">
                <span class="align-top">N/A</span>
                <input
                    type="checkbox"
                    v-model="form[id]"
                    :name="id"
                    true-value="N/A"
                >
            </label>
        </td>
        <td>
            <input
                type="text"
                class="form-control"
                v-model="form[`${id}_text`]"
                :id="`${id}_text`"
                placeholder="Type here..."
            >
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        number: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        form: {
            type: Object,
            required: true,
        },
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/RiskRowComponent.vue